import { render, staticRenderFns } from "./historyEdit.vue?vue&type=template&id=65f468dd&"
import script from "./historyEdit.vue?vue&type=script&lang=js&"
export * from "./historyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports